let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6B5C")).then(() => parcelRequire('hWmIe'));